import type { IpPalette } from '../theme'
import type { BrandSlug } from './brands'

// Per-IP brand palettes — the frontend is the sole source (the backend has no palette
// concept; see portal docs/project-notes.md). Each IP = a theme base + one brand colour;
// neutrals come from theme.ts's light/dark sets. Values from Figma 5O7ZqKz8BHiTjO2GYZurgn.
const WOMAN: IpPalette = { theme: 'light', brand: '#ff777a' }
const SUPERTASTE: IpPalette = { theme: 'light', brand: '#ff7500' }
const HEALTH: IpPalette = { theme: 'light', brand: '#41b849' }
const NEWS: IpPalette = { theme: 'light', brand: '#006cfe' }
const CARS: IpPalette = { theme: 'dark', brand: '#f2b016' }

// Keyed to the API's Brand enum (news | health | cars | supertaste | woman), the canonical
// form of brand_id. brand_id → slug resolution (including numeric-id aliases) lives in
// design-system/brands.ts's resolveBrand — this map only holds one palette per slug.
export const PALETTES: Record<BrandSlug, IpPalette> = {
  woman: WOMAN,
  supertaste: SUPERTASTE,
  health: HEALTH,
  news: NEWS,
  cars: CARS,
}
